<template>
    <div class="type-text-changer" :class="{ 'is-disabled': loading }">
        <div class="type-text-changer__types">
            <ul class="type-text-changer__list">
                <li class="type-text-changer__list-item type-text-changer__list-item--active">
                    <span
                        class="type-text-changer__type"
                        :class="`type-text-changer__type--${typeText.slug}`"
                    >
                        {{ typeText.label }}
                    </span>
                </li>
                <li
                    v-for="type in filteredTypes"
                    :key="type.slug"
                    class="type-text-changer__list-item"
                    @click="change(type.slug)"
                >
                    <span
                        class="type-text-changer__type"
                        :class="`type-text-changer__type--${type.slug}`"
                    >
                        {{ type.label }}
                    </span>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { updateBookpart } from '../../api/bookpart';

import { mapState } from 'vuex';

export default {
    name: 'TypeTextChanger',
    emits: ['change'],
    props: {
        bookpart: {
            type: Object,
            required: true
        },
        loading: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapState({
            types: state => state.settings.textTypes
        }),
        typeText() {
            return this.bookpart.type_text;
        },
        filteredTypes() {
            return this.types.filter(
                type => type.slug !== this.typeText.slug && type.slug !== 'list'
            );
        }
    },
    methods: {
        async change(slug) {
            try {
                await updateBookpart(this.bookpart.id, {
                    type_text: slug
                });

                console.log(this.$store.state.book);

                if (this.$store.state.book) {
                    this.$store.dispatch('fetchContents', this.$route.params.id);
                }

                this.$emit('change', slug);
            } catch (err) {
                console.log(err);
            }
        }
    }
};
</script>
